import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaePopup, {
    MdaePopupTitle,
    MdaePopupContent,   
  } from "../../../../common_components/common_widgets/popup"; 
import { isEqual } from "lodash";
import "./index.scss"; 
import { actions } from "async-ops";
import { SET_REMIT_DETAIL_DATA, TOGGLE_REMIT_DETAIL_POPUP } from '../remit-detail/reducers/remit-detail-reducer';
import MdaeTabPanel from "../../../../common_components/common_widgets/tab-panel";
import { Item } from "devextreme-react/tab-panel";
import RemitFields from './remit-fields';
import ExtraFields from './extra-fields';
import MedicareAdjudication from './medicare-adjudication';
import { GET_REMIT_DETAIL } from "./services/get-remit-detail";
import { GET_SELECTED_CASE_PAY_LINES } from "./services/get-selected-case-pay-lines";

export const toggleRemitDetailPopupVisible = (  
    dispatch,
    isVisible,    
    remitParams?
  ) => {     
    if(isVisible)
    {
      let isOutpatient = false;
      if (remitParams?.patientType != null) {
          let patientTypeParam = remitParams?.patientType?.toUpperCase().split(" ");
          let result = patientTypeParam.indexOf("OUTPATIENT");
          isOutpatient = result >= 0 ? true : false;
      }
      dispatch({
        type: SET_REMIT_DETAIL_DATA,
        data: {
          isOutpatient: isOutpatient,
          claimType: remitParams?.claimType,
          caseDetailId : remitParams?.caseDetailId 
        },
      }); 
      dispatch(actions.asyncOperationStart(GET_REMIT_DETAIL,remitParams));
      dispatch(actions.asyncOperationStart(GET_SELECTED_CASE_PAY_LINES,{caseDetailId : remitParams?.caseDetailId,eaCaseId : remitParams.eaCaseId,varToUpdate:remitParams.varToUpdate}));
    }
    dispatch({
      type: TOGGLE_REMIT_DETAIL_POPUP,
      data: {
        isRemitDetailPopupVisible: isVisible     
      },
    });  
  };
  
const RemitDetail : React.FC<any> = () => {
const dispatch = useDispatch();
const claimType = useSelector(
  (state) => state["remitDetailReducer"].claimType,
  isEqual
);
const varToUpdate = useSelector(
  (state) => state["billHistoryReducer"].varToUpdate,
  isEqual
);
const caseData = useSelector(
  (state) => state["billHistoryReducer"].caseData,
  isEqual
);
useEffect(()=>{
  dispatch({
    type: SET_REMIT_DETAIL_DATA,
    data: {
      varToUpdate,eaCaseId :caseData.eaCaseId
    },
  });
},[varToUpdate])

const getRemitDetailPopupTitle = () => {
    return (
        <MdaePopupTitle
        closePopupHandler={() => {
            toggleRemitDetailPopupVisible(dispatch,false);
        }}
        >    
        Remit Detail                            
        </MdaePopupTitle>
    );
};

return (
    <MdaePopup
        deferRendering={false}
        width={1300}     
        mdaeTitleRender= {getRemitDetailPopupTitle}           
        mdaeDataUpdaterConfig={[
        {
            actionType: TOGGLE_REMIT_DETAIL_POPUP,
            reducerName: "remitDetailReducer",
            widgetOptionBindings: {
            visible: "isRemitDetailPopupVisible"                     
            },
        },
        ]}  
        mdaeContentRender={() => {
        return (
            <div>
               <MdaePopupContent>
                <MdaeTabPanel>
                    <Item title="Remit Fields">
                        <RemitFields></RemitFields>
                    </Item>
                    <Item title="Extra Fields">
                        <ExtraFields></ExtraFields>
                    </Item>
                    { claimType?.toUpperCase() != "PROFESSIONAL" &&
                    <Item title="Medicare Adjudication">
                        <MedicareAdjudication></MedicareAdjudication>
                    </Item>
                    }
                </MdaeTabPanel> 
               </MdaePopupContent>                          
            </div>
        );
        }}            
    ></MdaePopup>
)
}

export default RemitDetail;